import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';
import { useWorkspaceUsers } from '@/hooks/api/0150_workspace_users';
import { useProducts } from '@/hooks/api/0390_products';
import { useMenuListedTeams } from '@/hooks/api/2260_menu_listed_teams';
import { useBusinessPartners } from '@/hooks/api/0430_business_partners';
import { useDashboardSearchCondition } from '@/providers/DashboardSearchConditionProvider';

export const SearchConditionTags = () => {
  const { _w_ } = useCurrentWorkspace();
  const { weeklyComparisonDashboardSearchCondition: searchCondition } = useDashboardSearchCondition();
  const { data: users } = useWorkspaceUsers({ identifier: _w_!.identifier });
  const { data: teams } = useMenuListedTeams({ identifier: _w_!.identifier });
  const { data: products } = useProducts({ identifier: _w_!.identifier });
  const { data: businessPartners } = useBusinessPartners({ identifier: _w_!.identifier, page: 1, per: 1000 });
  const isConditionExist = Object.values(searchCondition)
    .flat()
    .some((v) => v);

  if (!isConditionExist) return <></>;

  return (
    <div className="d-flex mb-2 align-items-center flex-wrap">
      {teams &&
        teams.purchase_order_teams
          .filter((d) => searchCondition.team_ids.includes(d.id))
          .map((d) => (
            <span key={`pm-tag-${d.id}`} className="badge rounded-pill badge-info mx-1 my-1">
              {d.name}
            </span>
          ))}
      {products &&
        products
          .filter((d) => searchCondition.product_ids.includes(d.id))
          .map((d) => (
            <span key={`phase-tag-${d.id}`} className="badge rounded-pill badge-info mx-1 my-1">
              {d.name}
            </span>
          ))}
      {users &&
        users
          .filter((d) => searchCondition.user_ids.includes(d.id))
          .map((d) => (
            <span key={`phase-tag-${d.id}`} className="badge rounded-pill badge-info mx-1 my-1">
              {d.user_account.name}
            </span>
          ))}
      {businessPartners &&
        businessPartners.business_partners
          .filter((d) => searchCondition.business_partner_ids.includes(d.id))
          .map((d) => (
            <span key={`bp-tag-${d.id}`} className="badge rounded-pill badge-info mx-1 my-1">
              {d.display_name}
            </span>
          ))}
      {businessPartners &&
        businessPartners.business_partners
          .filter((d) => searchCondition.agency_ids.includes(d.id))
          .map((d) => (
            <span key={`bp-tag-${d.id}`} className="badge rounded-pill badge-info mx-1 my-1">
              {d.display_name}
            </span>
          ))}
    </div>
  );
};
